const fields = [
  {
    key: 'firstName',
    type: 'input',
    required: true,
    templateOptions: {
      label: 'firstName'
    }
  },
  {
    key: 'lastName',
    type: 'input',
    templateOptions: {
      label: 'lastName'
    }
  },
  {
    key: 'middleName',
    type: 'input',
    templateOptions: {
      label: 'middleName'
    }
  },
  {
    key: 'birthYear',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'birthYear'
    }
  }
]

export default fields
